import tcnResponseTypes from "./tcnResponse.types";

//**************TCN RESPONSE  SEARCH START************************/
export const tcnResponseSearchStart = (data: any) => ({
  type: tcnResponseTypes.TCN_RESPONSE_SEARCH_START,
  payload: data,
});
export const tcnResponseSearchSuccess = (success: any) => ({
  type: tcnResponseTypes.TCN_RESPONSE_SEARCH_SUCCESS,
  payload: success,
});
export const tcnResponseSearchFailure = (error: any) => ({
  type: tcnResponseTypes.TCN_RESPONSE_SEARCH_FAILURE,
  payload: error,
});
export const tcnResponseSearchChanged = () => ({
  type: tcnResponseTypes.TCN_RESPONSE_SEARCH_CHANGED,
});
export const tcnResponseSearchReset = () => ({
  type: tcnResponseTypes.TCN_RESPONSE_SEARCH_RESET,
});

//**************TCN RESPONSE  SEARCH END************************/

export const getTCNDispositionGroupStart = (data: any) => ({
  type: tcnResponseTypes.TCN_DISPOSITION_GROUP_START,
  payload: data,
});

export const getTCNDispositionGroupSuccess = (success: any) => ({
  type: tcnResponseTypes.TCN_DISPOSITION_GROUP_SUCCESS,
  payload: success,
});

export const getTCNDispositionGroupFailure = (error: any) => ({
  type: tcnResponseTypes.TCN_DISPOSITION_GROUP_FAILURE,
  payload: error,
});

export const getTCNDispositionGroupResponseResetStart = () => ({
  type: tcnResponseTypes.TCN_DISPOSITION_GROUP_RESPONSE_RESET_START,
});

export const getTCNDispositionGroupResponseChanged = () => ({
  type: tcnResponseTypes.TCN_DISPOSITION_GROUP_RESPONSE_CHANGED,
});

//*******EXPORT TCN RESPONSE DETAILS START ********* */
export const tcnResponseExportAllStart = (tcnResponseList: any) => ({
  type: tcnResponseTypes.TCN_RESPONSE_EXPORT_START,
  payload: tcnResponseList,
});
export const tcnResponseExportAllSuccess = (success: any) => ({
  type: tcnResponseTypes.TCN_RESPONSE_EXPORT_SUCCESS,
  payload: success,
});
export const tcnResponseExportAllFailure = (failure: any) => ({
  type: tcnResponseTypes.TCN_RESPONSE_EXPORT_FAILURE,
  payload: failure,
});
export const tcnResponseExportAllReset = () => ({
  type: tcnResponseTypes.TCN_RESPONSE_EXPORT_CHANGED,
});
export const tcnResponseExportAllChanged = () => ({
  type: tcnResponseTypes.TCN_RESPONSE_EXPORT_RESET_START,
});
//*******EXPORT TCN RESPONSE DETAILS END ********* */
